/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import english from './supportedLanguages/en.json';
import french from './supportedLanguages/fr.json';
import amharic from './supportedLanguages/am.json';
import simplifiedChinese from './supportedLanguages/zh-CN.json';
import traditionalChinese from './supportedLanguages/zh-TW.json';
import spanish from './supportedLanguages/es.json';
import vietnamese from './supportedLanguages/vi.json';
import punjabi from './supportedLanguages/pa.json';
import tagalog from './supportedLanguages/tl.json';
import somali from './supportedLanguages/so.json';
import haitianCreole from './supportedLanguages/ht.json';
import portuguese from './supportedLanguages/pt.json';
import hindi from './supportedLanguages/hi.json';
import korean from './supportedLanguages/ko.json';
import german from './supportedLanguages/de.json';
import italian from './supportedLanguages/it.json';
import russian from './supportedLanguages/ru.json';
import polish from './supportedLanguages/pl.json';
import greek from './supportedLanguages/el.json';
import japanese from './supportedLanguages/ja.json';
import tamil from './supportedLanguages/ta.json';
import dutch from './supportedLanguages/nl.json';
import bengali from './supportedLanguages/bn.json';
import gujarati from './supportedLanguages/gu.json';
import ukrainian from './supportedLanguages/uk.json';
import romanian from './supportedLanguages/ro.json';
import arabic from './supportedLanguages/ar.json';
import urdu from './supportedLanguages/ur.json';
import thai from './supportedLanguages/th.json';
import hebrew from './supportedLanguages/he.json';
import khmer from './supportedLanguages/km.json';
import persian from './supportedLanguages/fa.json';
import armenian from './supportedLanguages/hy.json';
import burmese from './supportedLanguages/my.json';
import pashto from './supportedLanguages/ps.json';
import swahili from './supportedLanguages/sw.json';
import turkish from './supportedLanguages/tr.json';
import yiddish from './supportedLanguages/yi.json';
import oromo from './supportedLanguages/om.json';
import hmong from './supportedLanguages/hmn.json';
import yoruba from './supportedLanguages/yo.json';

// Country-specific language imports
import amharicEthiopia from './supportedLanguages/am-ET.json';
import arabicUAE from './supportedLanguages/ar-AE.json';
import arabicSaudiArabia from './supportedLanguages/ar-SA.json';
import bulgarianBulgaria from './supportedLanguages/bg-BG.json';
import bengaliBangladesh from './supportedLanguages/bn-BD.json';
import bosnianBosnia from './supportedLanguages/bs-BA.json';
import czechCzechRepublic from './supportedLanguages/cs-CZ.json';
import welshUK from './supportedLanguages/cy-GB.json';
import danishDenmark from './supportedLanguages/da-DK.json';
import germanAustria from './supportedLanguages/de-AT.json';
import germanSwitzerland from './supportedLanguages/de-CH.json';
import germanGermany from './supportedLanguages/de-DE.json';
import greekGreece from './supportedLanguages/el-GR.json';
import englishAustralia from './supportedLanguages/en-AU.json';
import englishCanada from './supportedLanguages/en-CA.json';
import englishUK from './supportedLanguages/en-GB.json';
import englishIreland from './supportedLanguages/en-IE.json';
import englishNewZealand from './supportedLanguages/en-NZ.json';
import englishUS from './supportedLanguages/en-US.json';
import spanishArgentina from './supportedLanguages/es-AR.json';
import spanishColombia from './supportedLanguages/es-CO.json';
import spanishSpain from './supportedLanguages/es-ES.json';
import spanishMexico from './supportedLanguages/es-MX.json';
import spanishUS from './supportedLanguages/es-US.json';
import estonianEstonia from './supportedLanguages/et-EE.json';
import persianIran from './supportedLanguages/fa-IR.json';
import finnishFinland from './supportedLanguages/fi-FI.json';
import frenchCanada from './supportedLanguages/fr-CA.json';
import frenchFrance from './supportedLanguages/fr-FR.json';
import irishIreland from './supportedLanguages/ga-IE.json';
import gujaratiIndia from './supportedLanguages/gu-IN.json';
import hebrewIsrael from './supportedLanguages/he-IL.json';
import hindiIndia from './supportedLanguages/hi-IN.json';
import croatianCroatia from './supportedLanguages/hr-HR.json';
import haitianCreoleHaiti from './supportedLanguages/ht-HT.json';
import hungarianHungary from './supportedLanguages/hu-HU.json';
import armenianArmenia from './supportedLanguages/hy-AM.json';
import indonesianIndonesia from './supportedLanguages/id-ID.json';
import icelandicIceland from './supportedLanguages/is-IS.json';
import italianItaly from './supportedLanguages/it-IT.json';
import japaneseJapan from './supportedLanguages/ja-JP.json';
import georgianGeorgia from './supportedLanguages/ka-GE.json';
import khmerCambodia from './supportedLanguages/km-KH.json';
import koreanSouthKorea from './supportedLanguages/ko-KR.json';
import lithuanianLithuania from './supportedLanguages/lt-LT.json';
import latvianLatvia from './supportedLanguages/lv-LV.json';
import malayMalaysia from './supportedLanguages/ms-MY.json';
import malteseMalta from './supportedLanguages/mt-MT.json';
import burmeseMyanmar from './supportedLanguages/my-MM.json';
import dutchBelgium from './supportedLanguages/nl-BE.json';
import dutchNetherlands from './supportedLanguages/nl-NL.json';
import norwegianNorway from './supportedLanguages/no-NO.json';
import punjabiIndia from './supportedLanguages/pa-IN.json';
import polishPoland from './supportedLanguages/pl-PL.json';
import pashtoAfghanistan from './supportedLanguages/ps-AF.json';
import portugueseBrazil from './supportedLanguages/pt-BR.json';
import portuguesePortugal from './supportedLanguages/pt-PT.json';
import romanianRomania from './supportedLanguages/ro-RO.json';
import russianRussia from './supportedLanguages/ru-RU.json';
import slovakSlovakia from './supportedLanguages/sk-SK.json';
import slovenianSlovenia from './supportedLanguages/sl-SI.json';
import somaliSomalia from './supportedLanguages/so-SO.json';
import albanianAlbania from './supportedLanguages/sq-AL.json';
import serbianSerbia from './supportedLanguages/sr-RS.json';
import swedishSweden from './supportedLanguages/sv-SE.json';
import swahiliKenya from './supportedLanguages/sw-KE.json';
import tamilIndia from './supportedLanguages/ta-IN.json';
import thaiThailand from './supportedLanguages/th-TH.json';
import tagalogPhilippines from './supportedLanguages/tl-PH.json';
import turkishTurkey from './supportedLanguages/tr-TR.json';
import ukrainianUkraine from './supportedLanguages/uk-UA.json';
import urduPakistan from './supportedLanguages/ur-PK.json';
import vietnameseVietnam from './supportedLanguages/vi-VN.json';
import yorubaNg from './supportedLanguages/yo-NG.json';
import yorubaBj from './supportedLanguages/yo-BJ.json';
import chineseHongKong from './supportedLanguages/zh-HK.json';
import chuukese from './supportedLanguages/chk.json';

export const LANGUAGES = {
  en: { title: 'English', localTitle: 'English', translation: english },
  fr: { title: 'French', localTitle: 'Français', translation: french },
  am: { title: 'Amharic', localTitle: 'አማርኛ', translation: amharic },
  'zh-CN': { title: 'Simplified Chinese', localTitle: '简体中文', translation: simplifiedChinese },
  'zh-TW': {
    title: 'Traditional Chinese',
    localTitle: '繁體中文',
    translation: traditionalChinese,
  },
  es: { title: 'Spanish', localTitle: 'Español', translation: spanish },
  vi: { title: 'Vietnamese', localTitle: 'Tiếng Việt', translation: vietnamese },
  pa: { title: 'Punjabi', localTitle: 'ਪੰਜਾਬੀ', translation: punjabi },
  tl: { title: 'Tagalog', localTitle: 'Tagalog', translation: tagalog },
  so: { title: 'Somali', localTitle: 'Soomaali', translation: somali },
  ht: { title: 'Haitian Creole', localTitle: 'Kreyòl Ayisyen', translation: haitianCreole },
  pt: { title: 'Portuguese', localTitle: 'Português', translation: portuguese },
  hi: { title: 'Hindi', localTitle: 'हिन्दी', translation: hindi },
  ko: { title: 'Korean', localTitle: '한국어', translation: korean },
  de: { title: 'German', localTitle: 'Deutsch', translation: german },
  it: { title: 'Italian', localTitle: 'Italiano', translation: italian },
  ru: { title: 'Russian', localTitle: 'Русский язык', translation: russian },
  pl: { title: 'Polish', localTitle: 'Polski', translation: polish },
  el: { title: 'Greek', localTitle: 'ελληνικά', translation: greek },
  ja: { title: 'Japanese', localTitle: '日本語', translation: japanese },
  ta: { title: 'Tamil', localTitle: 'தமிழ்', translation: tamil },
  nl: { title: 'Dutch', localTitle: 'Nederlands', translation: dutch },
  bn: { title: 'Bengali', localTitle: 'বাংলা', translation: bengali },
  gu: { title: 'Gujarati', localTitle: 'ગુજરાતી', translation: gujarati },
  uk: { title: 'Ukrainian', localTitle: 'українська мова', translation: ukrainian },
  ro: { title: 'Romanian', localTitle: 'limba română', translation: romanian },
  ar: { title: 'Arabic', localTitle: 'عربى', translation: arabic, rtl: true },
  ur: { title: 'Urdu', localTitle: 'اُردُو', translation: urdu, rtl: true },
  th: { title: 'Thai', localTitle: 'ภาษาไทย', translation: thai },
  he: { title: 'Hebrew', localTitle: 'עִברִית', translation: hebrew, rtl: true },
  km: { title: 'Khmer', localTitle: 'ភាសាខ្មែរ', translation: khmer },
  fa: { title: 'Persian', localTitle: 'فارسی', translation: persian, rtl: true },
  hy: { title: 'Armenian', localTitle: 'հայերէն', translation: armenian },
  my: { title: 'Burmese', localTitle: 'မြန်မာဘာသာ', translation: burmese },
  ps: { title: 'Pashto', localTitle: 'پښتو', translation: pashto, rtl: true },
  sw: { title: 'Swahili', localTitle: 'Kiswahili', translation: swahili },
  tr: { title: 'Turkish', localTitle: 'Türkiye', translation: turkish, rtl: true },
  yi: { title: 'Yiddish', localTitle: 'ייִדיש', translation: yiddish, rtl: true },
  om: { title: 'Oromo', localTitle: 'Oromoo', translation: oromo },
  hmn: { title: 'Hmong', localTitle: 'Hmoob', translation: hmong },
  yo: { title: 'Yoruba', localTitle: 'Yorùbá', translation: yoruba },

  // Country-specific variants
  'am-ET': { title: 'Amharic (Ethiopia)', localTitle: 'አማርኛ', translation: amharicEthiopia },
  'ar-AE': { title: 'Arabic (UAE)', localTitle: 'عربى', translation: arabicUAE, rtl: true },
  'ar-SA': { title: 'Arabic (Saudi Arabia)', localTitle: 'عربى', translation: arabicSaudiArabia, rtl: true },
  'bg-BG': { title: 'Bulgarian (Bulgaria)', localTitle: 'български език', translation: bulgarianBulgaria },
  'bn-BD': { title: 'Bengali (Bangladesh)', localTitle: 'বাংলা', translation: bengaliBangladesh },
  'bs-BA': { title: 'Bosnian (Bosnia and Herzegovina)', localTitle: 'bosanski jezik', translation: bosnianBosnia },
  'cs-CZ': { title: 'Czech (Czech Republic)', localTitle: 'čeština', translation: czechCzechRepublic },
  'cy-GB': { title: 'Welsh (UK)', localTitle: 'Cymraeg', translation: welshUK },
  'da-DK': { title: 'Danish (Denmark)', localTitle: 'dansk', translation: danishDenmark },
  'de-AT': { title: 'German (Austria)', localTitle: 'Deutsch', translation: germanAustria },
  'de-CH': { title: 'German (Switzerland)', localTitle: 'Deutsch', translation: germanSwitzerland },
  'de-DE': { title: 'German (Germany)', localTitle: 'Deutsch', translation: germanGermany },
  'el-GR': { title: 'Greek (Greece)', localTitle: 'ελληνικά', translation: greekGreece },
  'en-AU': { title: 'English (Australia)', localTitle: 'English (Australia)', translation: englishAustralia },
  'en-CA': { title: 'English (Canada)', localTitle: 'English (Canada)', translation: englishCanada },
  'en-GB': { title: 'English (UK)', localTitle: 'English (United Kingdom)', translation: englishUK },
  'en-IE': { title: 'English (Ireland)', localTitle: 'English (Ireland)', translation: englishIreland },
  'en-NZ': { title: 'English (New Zealand)', localTitle: 'English (New Zealand)', translation: englishNewZealand },
  'en-US': { title: 'English (US)', localTitle: 'English (United States)', translation: englishUS },
  'es-AR': { title: 'Spanish (Argentina)', localTitle: 'Español', translation: spanishArgentina },
  'es-CO': { title: 'Spanish (Colombia)', localTitle: 'Español', translation: spanishColombia },
  'es-ES': { title: 'Spanish (Spain)', localTitle: 'Español', translation: spanishSpain },
  'es-MX': { title: 'Spanish (Mexico)', localTitle: 'Español', translation: spanishMexico },
  'es-US': { title: 'Spanish (US)', localTitle: 'Español', translation: spanishUS },
  'et-EE': { title: 'Estonian (Estonia)', localTitle: 'eesti', translation: estonianEstonia },
  'fa-IR': { title: 'Persian (Iran)', localTitle: 'فارسی', translation: persianIran, rtl: true },
  'fi-FI': { title: 'Finnish (Finland)', localTitle: 'suomi', translation: finnishFinland },
  'fr-CA': { title: 'French (Canada)', localTitle: 'Français', translation: frenchCanada },
  'fr-FR': { title: 'French (France)', localTitle: 'Français', translation: frenchFrance },
  'ga-IE': { title: 'Irish (Ireland)', localTitle: 'Gaeilge', translation: irishIreland },
  'gu-IN': { title: 'Gujarati (India)', localTitle: 'ગુજરાતી', translation: gujaratiIndia },
  'he-IL': { title: 'Hebrew (Israel)', localTitle: 'עִברִית', translation: hebrewIsrael, rtl: true },
  'hi-IN': { title: 'Hindi (India)', localTitle: 'हिन्दी', translation: hindiIndia },
  'hr-HR': { title: 'Croatian (Croatia)', localTitle: 'hrvatski jezik', translation: croatianCroatia },
  'ht-HT': { title: 'Haitian Creole (Haiti)', localTitle: 'Kreyòl Ayisyen', translation: haitianCreoleHaiti },
  'hu-HU': { title: 'Hungarian (Hungary)', localTitle: 'Magyar', translation: hungarianHungary },
  'hy-AM': { title: 'Armenian (Armenia)', localTitle: 'հայերէն', translation: armenianArmenia },
  'id-ID': { title: 'Indonesian (Indonesia)', localTitle: 'Bahasa Indonesia', translation: indonesianIndonesia },
  'is-IS': { title: 'Icelandic (Iceland)', localTitle: 'Íslenska', translation: icelandicIceland },
  'it-IT': { title: 'Italian (Italy)', localTitle: 'Italiano', translation: italianItaly },
  'ja-JP': { title: 'Japanese (Japan)', localTitle: '日本語', translation: japaneseJapan },
  'ka-GE': { title: 'Georgian (Georgia)', localTitle: 'ქართული', translation: georgianGeorgia },
  'km-KH': { title: 'Khmer (Cambodia)', localTitle: 'ភាសាខ្មែរ', translation: khmerCambodia },
  'ko-KR': { title: 'Korean (South Korea)', localTitle: '한국어', translation: koreanSouthKorea },
  'lt-LT': { title: 'Lithuanian (Lithuania)', localTitle: 'lietuvių kalba', translation: lithuanianLithuania },
  'lv-LV': { title: 'Latvian (Latvia)', localTitle: 'latviešu valoda', translation: latvianLatvia },
  'ms-MY': { title: 'Malay (Malaysia)', localTitle: 'bahasa Melayu', translation: malayMalaysia },
  'mt-MT': { title: 'Maltese (Malta)', localTitle: 'Malti', translation: malteseMalta },
  'my-MM': { title: 'Burmese (Myanmar)', localTitle: 'မြန်မာဘာသာ', translation: burmeseMyanmar },
  'nl-BE': { title: 'Dutch (Belgium)', localTitle: 'Nederlands', translation: dutchBelgium },
  'nl-NL': { title: 'Dutch (Netherlands)', localTitle: 'Nederlands', translation: dutchNetherlands },
  'no-NO': { title: 'Norwegian (Norway)', localTitle: 'Norsk', translation: norwegianNorway },
  'pa-IN': { title: 'Punjabi (India)', localTitle: 'ਪੰਜਾਬੀ', translation: punjabiIndia },
  'pl-PL': { title: 'Polish (Poland)', localTitle: 'Polski', translation: polishPoland },
  'ps-AF': { title: 'Pashto (Afghanistan)', localTitle: 'پښتو', translation: pashtoAfghanistan, rtl: true },
  'pt-BR': { title: 'Portuguese (Brazil)', localTitle: 'Português', translation: portugueseBrazil },
  'pt-PT': { title: 'Portuguese (Portugal)', localTitle: 'Português', translation: portuguesePortugal },
  'ro-RO': { title: 'Romanian (Romania)', localTitle: 'limba română', translation: romanianRomania },
  'ru-RU': { title: 'Russian (Russia)', localTitle: 'Русский язык', translation: russianRussia },
  'sk-SK': { title: 'Slovak (Slovakia)', localTitle: 'slovenčina', translation: slovakSlovakia },
  'sl-SI': { title: 'Slovenian (Slovenia)', localTitle: 'slovenščina', translation: slovenianSlovenia },
  'so-SO': { title: 'Somali (Somalia)', localTitle: 'Soomaali', translation: somaliSomalia },
  'sq-AL': { title: 'Albanian (Albania)', localTitle: 'shqip', translation: albanianAlbania },
  'sr-RS': { title: 'Serbian (Serbia)', localTitle: 'српски језик', translation: serbianSerbia },
  'sv-SE': { title: 'Swedish (Sweden)', localTitle: 'Svenska', translation: swedishSweden },
  'sw-KE': { title: 'Swahili (Kenya)', localTitle: 'Kiswahili', translation: swahiliKenya },
  'ta-IN': { title: 'Tamil (India)', localTitle: 'தமிழ்', translation: tamilIndia },
  'th-TH': { title: 'Thai (Thailand)', localTitle: 'ภาษาไทย', translation: thaiThailand },
  'tl-PH': { title: 'Tagalog (Philippines)', localTitle: 'Tagalog', translation: tagalogPhilippines },
  'tr-TR': { title: 'Turkish (Turkey)', localTitle: 'Türkiye', translation: turkishTurkey, rtl: true },
  'uk-UA': { title: 'Ukrainian (Ukraine)', localTitle: 'українська мова', translation: ukrainianUkraine },
  'ur-PK': { title: 'Urdu (Pakistan)', localTitle: 'اُردُو', translation: urduPakistan, rtl: true },
  'vi-VN': { title: 'Vietnamese (Vietnam)', localTitle: 'Tiếng Việt', translation: vietnameseVietnam },
  'yo-NG': { title: 'Yoruba (Nigeria)', localTitle: 'Yorùbá (Nàìjíríà)', translation: yorubaNg },
  'yo-BJ': { title: 'Yoruba (Benin)', localTitle: 'Yorùbá (Bẹ̀nẹ̀)', translation: yorubaBj },
  'zh-HK': { title: 'Chinese (Hong Kong)', localTitle: '繁體中文', translation: chineseHongKong },
  chk: { title: 'Chuukese', localTitle: 'Trukese', translation: chuukese },
};

export type LanguageCode = keyof typeof LANGUAGES;

export const getLanguageCodeFromKey = (key: LanguageCode) => {
  switch (key) {
    case 'en':
      return LANGUAGES.en;
    case 'fr':
      return LANGUAGES.fr;
    case 'am':
      return LANGUAGES.am;
    case 'zh-CN':
      return LANGUAGES['zh-CN'];
    case 'zh-TW':
      return LANGUAGES['zh-TW'];
    case 'es':
      return LANGUAGES.es;
    case 'vi':
      return LANGUAGES.vi;
    case 'pa':
      return LANGUAGES.pa;
    case 'tl':
      return LANGUAGES.tl;
    case 'so':
      return LANGUAGES.so;
    case 'ht':
      return LANGUAGES.ht;
    case 'pt':
      return LANGUAGES.pt;
    case 'hi':
      return LANGUAGES.hi;
    case 'ko':
      return LANGUAGES.ko;
    case 'de':
      return LANGUAGES.de;
    case 'it':
      return LANGUAGES.it;
    case 'ru':
      return LANGUAGES.ru;
    case 'pl':
      return LANGUAGES.pl;
    case 'el':
      return LANGUAGES.el;
    case 'ja':
      return LANGUAGES.ja;
    case 'ta':
      return LANGUAGES.ta;
    case 'nl':
      return LANGUAGES.nl;
    case 'bn':
      return LANGUAGES.bn;
    case 'gu':
      return LANGUAGES.gu;
    case 'uk':
      return LANGUAGES.uk;
    case 'ro':
      return LANGUAGES.ro;
    case 'ar':
      return LANGUAGES.ar;
    case 'ur':
      return LANGUAGES.ur;
    case 'th':
      return LANGUAGES.th;
    case 'he':
      return LANGUAGES.he;
    case 'km':
      return LANGUAGES.km;
    case 'fa':
      return LANGUAGES.fa;
    case 'hy':
      return LANGUAGES.hy;
    case 'my':
      return LANGUAGES.my;
    case 'ps':
      return LANGUAGES.ps;
    case 'sw':
      return LANGUAGES.sw;
    case 'tr':
      return LANGUAGES.tr;
    case 'yi':
      return LANGUAGES.yi;
    case 'om':
      return LANGUAGES.om;
    case 'hmn':
      return LANGUAGES.hmn;
    case 'yo':
      return LANGUAGES.yo;

    // Country-specific variants
    case 'am-ET':
      return LANGUAGES['am-ET'];
    case 'ar-AE':
      return LANGUAGES['ar-AE'];
    case 'ar-SA':
      return LANGUAGES['ar-SA'];
    case 'bg-BG':
      return LANGUAGES['bg-BG'];
    case 'bn-BD':
      return LANGUAGES['bn-BD'];
    case 'bs-BA':
      return LANGUAGES['bs-BA'];
    case 'cs-CZ':
      return LANGUAGES['cs-CZ'];
    case 'cy-GB':
      return LANGUAGES['cy-GB'];
    case 'da-DK':
      return LANGUAGES['da-DK'];
    case 'de-AT':
      return LANGUAGES['de-AT'];
    case 'de-CH':
      return LANGUAGES['de-CH'];
    case 'de-DE':
      return LANGUAGES['de-DE'];
    case 'el-GR':
      return LANGUAGES['el-GR'];
    case 'en-AU':
      return LANGUAGES['en-AU'];
    case 'en-CA':
      return LANGUAGES['en-CA'];
    case 'en-GB':
      return LANGUAGES['en-GB'];
    case 'en-IE':
      return LANGUAGES['en-IE'];
    case 'en-NZ':
      return LANGUAGES['en-NZ'];
    case 'en-US':
      return LANGUAGES['en-US'];
    case 'es-AR':
      return LANGUAGES['es-AR'];
    case 'es-CO':
      return LANGUAGES['es-CO'];
    case 'es-ES':
      return LANGUAGES['es-ES'];
    case 'es-MX':
      return LANGUAGES['es-MX'];
    case 'es-US':
      return LANGUAGES['es-US'];
    case 'et-EE':
      return LANGUAGES['et-EE'];
    case 'fa-IR':
      return LANGUAGES['fa-IR'];
    case 'fi-FI':
      return LANGUAGES['fi-FI'];
    case 'fr-CA':
      return LANGUAGES['fr-CA'];
    case 'fr-FR':
      return LANGUAGES['fr-FR'];
    case 'ga-IE':
      return LANGUAGES['ga-IE'];
    case 'gu-IN':
      return LANGUAGES['gu-IN'];
    case 'he-IL':
      return LANGUAGES['he-IL'];
    case 'hi-IN':
      return LANGUAGES['hi-IN'];
    case 'hr-HR':
      return LANGUAGES['hr-HR'];
    case 'ht-HT':
      return LANGUAGES['ht-HT'];
    case 'hu-HU':
      return LANGUAGES['hu-HU'];
    case 'hy-AM':
      return LANGUAGES['hy-AM'];
    case 'id-ID':
      return LANGUAGES['id-ID'];
    case 'is-IS':
      return LANGUAGES['is-IS'];
    case 'it-IT':
      return LANGUAGES['it-IT'];
    case 'ja-JP':
      return LANGUAGES['ja-JP'];
    case 'ka-GE':
      return LANGUAGES['ka-GE'];
    case 'km-KH':
      return LANGUAGES['km-KH'];
    case 'ko-KR':
      return LANGUAGES['ko-KR'];
    case 'lt-LT':
      return LANGUAGES['lt-LT'];
    case 'lv-LV':
      return LANGUAGES['lv-LV'];
    case 'ms-MY':
      return LANGUAGES['ms-MY'];
    case 'mt-MT':
      return LANGUAGES['mt-MT'];
    case 'my-MM':
      return LANGUAGES['my-MM'];
    case 'nl-BE':
      return LANGUAGES['nl-BE'];
    case 'nl-NL':
      return LANGUAGES['nl-NL'];
    case 'no-NO':
      return LANGUAGES['no-NO'];
    case 'pa-IN':
      return LANGUAGES['pa-IN'];
    case 'pl-PL':
      return LANGUAGES['pl-PL'];
    case 'ps-AF':
      return LANGUAGES['ps-AF'];
    case 'pt-BR':
      return LANGUAGES['pt-BR'];
    case 'pt-PT':
      return LANGUAGES['pt-PT'];
    case 'ro-RO':
      return LANGUAGES['ro-RO'];
    case 'ru-RU':
      return LANGUAGES['ru-RU'];
    case 'sk-SK':
      return LANGUAGES['sk-SK'];
    case 'sl-SI':
      return LANGUAGES['sl-SI'];
    case 'so-SO':
      return LANGUAGES['so-SO'];
    case 'sq-AL':
      return LANGUAGES['sq-AL'];
    case 'sr-RS':
      return LANGUAGES['sr-RS'];
    case 'sv-SE':
      return LANGUAGES['sv-SE'];
    case 'sw-KE':
      return LANGUAGES['sw-KE'];
    case 'ta-IN':
      return LANGUAGES['ta-IN'];
    case 'th-TH':
      return LANGUAGES['th-TH'];
    case 'tl-PH':
      return LANGUAGES['tl-PH'];
    case 'tr-TR':
      return LANGUAGES['tr-TR'];
    case 'uk-UA':
      return LANGUAGES['uk-UA'];
    case 'ur-PK':
      return LANGUAGES['ur-PK'];
    case 'vi-VN':
      return LANGUAGES['vi-VN'];
    case 'yo-NG':
      return LANGUAGES['yo-NG'];
    case 'yo-BJ':
      return LANGUAGES['yo-BJ'];
    case 'zh-HK':
      return LANGUAGES['zh-HK'];
    case 'chk':
      return LANGUAGES.chk;
    default:
      return null;
  }
};
